// Sticky nav + mobile burger.
//
// Both handlers here used to be performance problems:
//  - onscroll ran unthrottled and read scrollTop (forcing reflow) then wrote a class
//    on every single scroll event, even when the class was already correct.
//  - onresize called adjustStyle(), which re-bound a NEW $('#nav-burger').click()
//    handler every time. resize fires continuously while dragging, on rotation, and on
//    mobile whenever the URL bar collapses - so handlers accumulated without bound and
//    one tap eventually toggled the menu N times.

(function () {
    var MOBILE = '(max-width:768px)';

    // --- Sticky nav -------------------------------------------------------------
    var $menuTop = null;
    var isFixed = false;
    var scrollQueued = false;

    function applyFixedState() {
        scrollQueued = false;

        if ($menuTop === null || $menuTop.length === 0) {
            $menuTop = $('.menu-top');
        }

        var scrolled = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > 0;

        // Only touch the DOM when the state actually changes.
        if (scrolled === isFixed) {
            return;
        }

        isFixed = scrolled;
        $menuTop.toggleClass('is-fixed', scrolled);
    }

    window.addEventListener('scroll', function () {
        if (!scrollQueued) {
            scrollQueued = true;
            window.requestAnimationFrame(applyFixedState);
        }
    }, { passive: true });

    // --- Mobile burger ----------------------------------------------------------
    $(document).ready(function () {
        // Bound exactly once. Delegated from document so it survives DOM replacement,
        // and the open/closed state lives on the element's class rather than in a
        // closure variable, so there is nothing to get out of sync.
        $(document).on('click', '#nav-burger', function () {
            if (window.matchMedia(MOBILE).matches) {
                $('.alt-nav').toggleClass('shown');
            }
        });

        // Leaving mobile width closes the panel so it can't be stranded open.
        var resizeTimer = null;
        window.addEventListener('resize', function () {
            if (resizeTimer) {
                clearTimeout(resizeTimer);
            }
            resizeTimer = setTimeout(function () {
                resizeTimer = null;
                if (!window.matchMedia(MOBILE).matches) {
                    $('.alt-nav').removeClass('shown');
                }
            }, 150);
        });
    });
})();
